const labels = document.querySelectorAll('.bottom_label');

for (let idx = 0; idx < labels.length; idx++) {
  const label = labels[idx];
  const id = label.getAttribute('id');
  const listEl = document.querySelector(`.${id}`);
  const plusEl = document.querySelector(`#${id} .plus`);
  const minusEl = document.querySelector(`#${id} .minus`);

  label.addEventListener('click', () => {
    listEl.classList.toggle('showhide');
    plusEl.classList.toggle('display-none');
    minusEl.classList.toggle('display-none');
  });
}
